export function maps() {
    return {
        "0": {
            "id": "0",
            "image": "Atlas2Maps/Lookout1.png",
            "name": "Lookout",
            "tier": 1,
            "unique": false,

            "shaped_image": "Atlas2Maps/Lookout2.png",

        },
        "1": {
            "id": "1",
            "image": "Atlas2Maps/Beach1.png",
            "name": "Beach",
            "tier": 1,
            "unique": false,

            "shaped_image": "Atlas2Maps/Beach2.png",

        },
        "2": {
            "id": "2",
            "image": "Atlas2Maps/Graveyard1.png",
            "name": "Graveyard",
            "tier": 1,
            "unique": false,

            "shaped_image": "Atlas2Maps/Graveyard2.png",

        },
        "3": {
            "id": "3",
            "image": "Atlas2Maps/Dungeon1.png",
            "name": "Dungeon",
            "tier": 1,
            "unique": false,

            "shaped_image": "Atlas2Maps/Dungeon2.png",

        },
        "4": {
            "id": "4",
            "image": "Atlas2Maps/Alleyways1.png",
            "name": "Alleyways",
            "tier": 2,
            "unique": false,

            "shaped_image": "Atlas2Maps/Alleyways2.png",

        },
        "5": {
            "id": "5",
            "image": "Atlas2Maps/Pen1.png",
            "name": "Pen",
            "tier": 2,
            "unique": false,

            "shaped_image": "Atlas2Maps/Pen2.png",

        },
        "6": {
            "id": "6",
            "image": "Atlas2Maps/Desert1.png",
            "name": "Desert",
            "tier": 2,
            "unique": false,

            "shaped_image": "Atlas2Maps/Desert2.png",

        },
        "7": {
            "id": "7",
            "image": "Atlas2Maps/AridLake1.png",
            "name": "Arid Lake",
            "tier": 2,
            "unique": false,

            "shaped_image": "Atlas2Maps/AridLake2.png",

        },
        "8": {
            "id": "8",
            "image": "Atlas2Maps/Cavern1.png",
            "name": "Flooded Mine",
            "tier": 2,
            "unique": false,

            "shaped_image": "Atlas2Maps/Cavern2.png",

        },
        "9": {
            "id": "9",
            "image": "Atlas2Maps/Marshes1.png",
            "name": "Marshes",
            "tier": 2,
            "unique": false,

            "shaped_image": "Atlas2Maps/Marshes2.png",

        },
        "10": {
            "id": "10",
            "image": "Atlas2Maps/Iceberg1.png",
            "name": "Iceberg",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Iceberg2.png",

        },
        "11": {
            "id": "11",
            "image": "Atlas2Maps/Cage1.png",
            "name": "Cage",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Cage2.png",

        },
        "12": {
            "id": "12",
            "image": "Atlas2Maps/Springs1.png",
            "name": "Springs",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Springs2.png",

        },
        "13": {
            "id": "13",
            "image": "Atlas2Maps/Excavation1.png",
            "name": "Excavation",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Excavation2.png",

        },
        "14": {
            "id": "14",
            "image": "Atlas2Maps/SulphurWastes1.png",
            "name": "Leyline",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/SulphurWastes2.png",

        },
        "15": {
            "id": "15",
            "image": "Atlas2Maps/DryPeninsula1.png",
            "name": "Peninsula",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/DryPeninsula2.png",

        },
        "16": {
            "id": "16",
            "image": "Atlas2Maps/Quay1.png",
            "name": "Port",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Quay2.png",

        },
        "17": {
            "id": "17",
            "image": "Atlas2Maps/BurialChambers1.png",
            "name": "Burial Chambers",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/BurialChambers2.png",

        },
        "18": {
            "id": "18",
            "image": "Atlas2Maps/Cells1.png",
            "name": "Cells",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Cells2.png",

        },
        "19": {
            "id": "19",
            "image": "Atlas2Maps/Arcade1.png",
            "name": "Arcade",
            "tier": 3,
            "unique": false,

            "shaped_image": "Atlas2Maps/Arcade2.png",

        },
        "20": {
            "id": "20",
            "image": "Atlas2Maps/CitySquare1.png",
            "name": "City Square",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/CitySquare2.png",

        },
        "21": {
            "id": "21",
            "image": "Atlas2Maps/Antiquary1.png",
            "name": "Relic Chambers",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Antiquary2.png",

        },
        "22": {
            "id": "22",
            "image": "Atlas2Maps/Courthouse1.png",
            "name": "Courthouse",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Courthouse2.png",

        },
        "23": {
            "id": "23",
            "image": "Atlas2Maps/Strand1.png",
            "name": "Strand",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Strand2.png",

        },
        "24": {
            "id": "24",
            "image": "UniqueMapEye.png",
            "name": "Whakawairua Tuahu",
            "tier": 4,
            "unique": true,
        },
        "25": {
            "id": "25",
            "image": "Atlas2Maps/Chateau1.png",
            "name": "Chateau",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Chateau2.png",

        },
        "26": {
            "id": "26",
            "image": "Atlas2Maps/Grotto1.png",
            "name": "Grotto",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Grotto2.png",

        },
        "27": {
            "id": "27",
            "image": "Atlas2Maps/Gorge1.png",
            "name": "Gorge",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Gorge2.png",

        },
        "28": {
            "id": "28",
            "image": "Atlas2Maps/Volcano1.png",
            "name": "Volcano",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Volcano2.png",

        },
        "29": {
            "id": "29",
            "image": "Atlas2Maps/Beacon1.png",
            "name": "Lighthouse",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Beacon2.png",

        },
        "30": {
            "id": "30",
            "image": "Atlas2Maps/Canyon1.png",
            "name": "Canyon",
            "tier": 4,
            "unique": false,

            "shaped_image": "Atlas2Maps/Canyon2.png",

        },
        "31": {
            "id": "31",
            "image": "Atlas2Maps/Baths1.png",
            "name": "Conservatory",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Baths2.png",

        },
        "32": {
            "id": "32",
            "image": "Atlas2Maps/Corrosion1.png",
            "name": "Sulphur Vents",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Corrosion2.png",

        },
        "33": {
            "id": "33",
            "image": "Atlas2Maps/Chambers1.png",
            "name": "Haunted Mansion",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Chambers2.png",

        },
        "34": {
            "id": "34",
            "image": "Atlas2Maps/Maze1.png",
            "name": "Maze",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Maze2.png",

        },
        "35": {
            "id": "35",
            "image": "Atlas2Maps/Channel1.png",
            "name": "Channel",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Channel2.png",

        },
        "36": {
            "id": "36",
            "image": "Atlas2Maps/Sewer1.png",
            "name": "Toxic Sewer",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Sewer2.png",

        },
        "37": {
            "id": "37",
            "image": "Atlas2Maps/VaalCity1.png",
            "name": "Ancient City",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/VaalCity2.png",

        },
        "38": {
            "id": "38",
            "image": "Atlas2Maps/IvoryTemple1.png",
            "name": "Ivory Temple",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/IvoryTemple2.png",

        },
        "39": {
            "id": "39",
            "image": "Atlas2Maps/SpiderLair1.png",
            "name": "Spider Lair",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/SpiderLair2.png",

        },
        "40": {
            "id": "40",
            "image": "Atlas2Maps/Barrows1.png",
            "name": "Barrows",
            "tier": 5,
            "unique": false,

            "shaped_image": "Atlas2Maps/Barrows2.png",

        },
        "41": {
            "id": "41",
            "image": "Atlas2Maps/Mausoleum2.png",
            "name": "Mausoleum",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Mausoleum3.png",

        },
        "42": {
            "id": "42",
            "image": "Atlas2Maps/Fields2.png",
            "name": "Fields",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Fields3.png",

        },
        "43": {
            "id": "43",
            "image": "Atlas2Maps/JungleValley2.png",
            "name": "Jungle Valley",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/JungleValley3.png",

        },
        "44": {
            "id": "44",
            "image": "Atlas2Maps/Phantasmagoria2.png",
            "name": "Phantasmagoria",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Phantasmagoria3.png",

        },
        "45": {
            "id": "45",
            "image": "Atlas2Maps/Academy2.png",
            "name": "Academy",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Academy3.png",

        },
        "46": {
            "id": "46",
            "image": "Atlas2Maps/Thicket2.png",
            "name": "Thicket",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Thicket3.png",

        },
        "47": {
            "id": "47",
            "image": "Atlas2Maps/Wharf2.png",
            "name": "Wharf",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Wharf3.png",

        },
        "48": {
            "id": "48",
            "image": "Atlas2Maps/DryWoods2.png",
            "name": "Ashen Wood",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/DryWoods3.png",

        },
        "49": {
            "id": "49",
            "image": "Atlas2Maps/Atoll2.png",
            "name": "Atoll",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Atoll3.png",

        },
        "50": {
            "id": "50",
            "image": "MaelstromofChaos.png",
            "name": "Maelström of Chaos",
            "tier": 6,
            "unique": true,
        },
        "51": {
            "id": "51",
            "image": "Atlas2Maps/Cemetery2.png",
            "name": "Cemetery",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/Cemetery3.png",

        },
        "52": {
            "id": "52",
            "image": "HallowedGround.png",
            "name": "Hallowed Ground",
            "tier": 6,
            "unique": true,
        },
        "53": {
            "id": "53",
            "image": "Atlas2Maps/UndergroundSea2.png",
            "name": "Underground Sea",
            "tier": 6,
            "unique": false,

            "shaped_image": "Atlas2Maps/UndergroundSea3.png",

        },
        "54": {
            "id": "54",
            "image": "Atlas2Maps/Tribunal2.png",
            "name": "Tribunal",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Tribunal3.png",

        },
        "55": {
            "id": "55",
            "image": "Atlas2Maps/CorpseTrench2.png",
            "name": "Coral Ruins",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/CorpseTrench3.png",

        },
        "56": {
            "id": "56",
            "image": "Atlas2Maps/Crematorium2.png",
            "name": "Lava Chamber",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Crematorium3.png",

        },
        "57": {
            "id": "57",
            "image": "Atlas2Maps/Residence2.png",
            "name": "Residence",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Residence3.png",

        },
        "58": {
            "id": "58",
            "image": "Atlas2Maps/Ramparts2.png",
            "name": "Ramparts",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Ramparts3.png",

        },
        "59": {
            "id": "59",
            "image": "Atlas2Maps/Dunes2.png",
            "name": "Dunes",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Dunes3.png",

        },
        "60": {
            "id": "60",
            "image": "PillarsOfVastiri.png",
            "name": "Pillars of Arun",
            "tier": 7,
            "unique": true,
        },
        "61": {
            "id": "61",
            "image": "Atlas2Maps/Catacomb2.png",
            "name": "Bone Crypt",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Catacomb3.png",

        },
        "62": {
            "id": "62",
            "image": "olmec.png",
            "name": "Olmec's Sanctum",
            "tier": 7,
            "unique": true,
        },
        "63": {
            "id": "63",
            "image": "Atlas2Maps/UndergroundRiver2.png",
            "name": "Underground River",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/UndergroundRiver3.png",

        },
        "64": {
            "id": "64",
            "image": "WolfMap.png",
            "name": "Caer Blaidd, Wolfpack's Den",
            "tier": 7,
            "unique": true,
        },
        "65": {
            "id": "65",
            "image": "Atlas2Maps/Terrace2.png",
            "name": "Gardens",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Terrace3.png",

        },
        "66": {
            "id": "66",
            "image": "Atlas2Maps/ArachnidNest2.png",
            "name": "Arachnid Nest",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/ArachnidNest3.png",

        },
        "67": {
            "id": "67",
            "image": "Atlas2Maps/Bazaar2.png",
            "name": "Bazaar",
            "tier": 7,
            "unique": false,

            "shaped_image": "Atlas2Maps/Bazaar3.png",

        },
        "68": {
            "id": "68",
            "image": "Atlas2Maps/Laboratory2.png",
            "name": "Laboratory",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/Laboratory3.png",

        },
        "69": {
            "id": "69",
            "image": "Atlas2Maps/Infestation2.png",
            "name": "Infested Valley",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/Infestation3.png",

        },
        "70": {
            "id": "70",
            "image": "Atlas2Maps/OvergrownRuin2.png",
            "name": "Overgrown Ruin",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/OvergrownRuin3.png",

        },
        "71": {
            "id": "71",
            "image": "Atlas2Maps/VaalPyramid2.png",
            "name": "Vaal Pyramid",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/VaalPyramid3.png",

        },
        "72": {
            "id": "72",
            "image": "UniqueMap1.png",
            "name": "Vaults of Atziri",
            "tier": 8,
            "unique": true,
        },
        "73": {
            "id": "73",
            "image": "Atlas2Maps/Quarry2.png",
            "name": "Geode",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/Quarry3.png",

        },
        "74": {
            "id": "74",
            "image": "Atlas2Maps/Armory2.png",
            "name": "Armoury",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/Armory3.png",

        },
        "75": {
            "id": "75",
            "image": "Atlas2Maps/Courtyard2.png",
            "name": "Courtyard",
            "tier": 8,
            "unique": false,

            "shaped_image": "Atlas2Maps/Courtyard3.png",

        },
        "76": {
            "id": "76",
            "image": "TheVinktarSquare.png",
            "name": "The Vinktar Square",
            "tier": 8,
            "unique": true,
        },
        "77": {
            "id": "77",
            "image": "Atlas2Maps/MudGeyser2.png",
            "name": "Mud Geyser",
            "tier": 8,
            "unique": false,
            "shaped_image": "Atlas2Maps/MudGeyser3.png",

        },
        "78": {
            "id": "78",
            "image": "Atlas2Maps/Shore2.png",
            "name": "Shore",
            "tier": 8,
            "unique": false,
            "shaped_image": "Atlas2Maps/Shore3.png",
        },
        "79": {
            "id": "79",
            "image": "FairgravesMap01.png",
            "name": "Mao Kun",
            "tier": 8,
            "unique": true,
        },
        "80": {
            "id": "80",
            "image": "Atlas2Maps/TropicalIsland2.png",
            "name": "Tropical Island",
            "tier": 8,
            "unique": false,
            "shaped_image": "Atlas2Maps/TropicalIsland3.png",
        },
        "81": {
            "id": "81",
            "image": "Atlas2Maps/MineralPools2.png",
            "name": "Mineral Pools",
            "tier": 8,
            "unique": false,
            "shaped_image": "Atlas2Maps/MineralPools3.png",
        },
        "82": {
            "id": "82",
            "image": "Atlas2Maps/LunarisTemple2.png",
            "name": "Moon Temple",
            "tier": 9,
            "unique": false,
            "shaped_image": "Atlas2Maps/LunarisTemple3.png",
        },
        "83": {
            "id": "83",
            "image": "Celestial.png",
            "name": "The Twilight Temple",
            "tier": 9,
            "unique": true,
        },
        "84": {
            "id": "84",
            "image": "Atlas2Maps/Sepulchre2.png",
            "name": "Sepulchre",
            "tier": 9,
            "unique": false,
            "shaped_image": "Atlas2Maps/Sepulchre3.png",
        },
        "85": {
            "id": "85",
            "image": "Atlas2Maps/Tower2.png",
            "name": "Tower",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Tower3.png",

        },
        "86": {
            "id": "86",
            "image": "Atlas2Maps/WastePool2.png",
            "name": "Waste Pool",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/WastePool3.png",

        },
        "87": {
            "id": "87",
            "image": "Atlas2Maps/Plateau2.png",
            "name": "Plateau",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Plateau3.png",

        },
        "88": {
            "id": "88",
            "image": "Atlas2Maps/Estuary2.png",
            "name": "Estuary",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Estuary3.png",

        },
        "89": {
            "id": "89",
            "image": "Atlas2Maps/Vault2.png",
            "name": "Vault",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Vault3.png",

        },
        "90": {
            "id": "90",
            "image": "Atlas2Maps/Temple2.png",
            "name": "Temple",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Temple3.png",

        },
        "91": {
            "id": "91",
            "image": "PoorjoysAsylum.png",
            "name": "Poorjoy's Asylum",
            "tier": 9,
            "unique": true,
        },
        "92": {
            "id": "92",
            "image": "Atlas2Maps/Arena2.png",
            "name": "Arena",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Arena3.png",

        },
        "93": {
            "id": "93",
            "image": "Atlas2Maps/Museum2.png",
            "name": "Museum",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Museum3.png",

        },
        "94": {
            "id": "94",
            "image": "PutridCloister.png",
            "name": "The Putrid Cloister",
            "tier": 9,
            "unique": true,
        },
        "95": {
            "id": "95",
            "image": "Atlas2Maps/Scriptorium2.png",
            "name": "Scriptorium",
            "tier": 9,
            "unique": false,

            "shaped_image": "Atlas2Maps/Scriptorium3.png",

        },
        "96": {
            "id": "96",
            "image": "Atlas2Maps/Boulevard2.png",
            "name": "Siege",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Boulevard3.png",

        },
        "97": {
            "id": "97",
            "image": "Atlas2Maps/Shipyard2.png",
            "name": "Shipyard",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Shipyard3.png",

        },
        "98": {
            "id": "98",
            "image": "Atlas2Maps/Belfry2.png",
            "name": "Belfry",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Belfry3.png",

        },
        "99": {
            "id": "99",
            "image": "Atlas2Maps/ArachnidTomb2.png",
            "name": "Arachnid Tomb",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/ArachnidTomb3.png",

        },
        "100": {
            "id": "100",
            "image": "Atlas2Maps/Wasteland2.png",
            "name": "Wasteland",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Wasteland3.png",

        },
        "101": {
            "id": "101",
            "image": "Atlas2Maps/Precinct2.png",
            "name": "Precinct",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Precinct3.png",

        },
        "102": {
            "id": "102",
            "image": "Atlas2Maps/Bog2.png",
            "name": "Bog",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Bog3.png",

        },
        "103": {
            "id": "103",
            "image": "Atlas2Maps/Pier2.png",
            "name": "Pier",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Pier3.png",

        },
        "104": {
            "id": "104",
            "image": "Atlas2Maps/Crypt2.png",
            "name": "Cursed Crypt",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Crypt3.png",

        },
        "105": {
            "id": "105",
            "image": "UndeadSiege.png",
            "name": "The Coward's Trial",
            "tier": 10,
            "unique": true,
        },
        "106": {
            "id": "106",
            "image": "Atlas2Maps/Orchard2.png",
            "name": "Orchard",
            "tier": 10,
            "unique": false,

            "shaped_image": "Atlas2Maps/Orchard3.png",

        },
        "107": {
            "id": "107",
            "image": "Atlas2Maps/Promenade3.png",
            "name": "Promenade",
            "tier": 11,
            "unique": false,
        },
        "108": {
            "id": "108",
            "image": "HallOfGrandmasters.png",
            "name": "The Hall of Grandmasters",
            "tier": 11,
            "unique": true,
        },
        "109": {
            "id": "109",
            "image": "Atlas2Maps/Lair3.png",
            "name": "Lair",
            "tier": 11,
            "unique": false,
        },
        "110": {
            "id": "110",
            "image": "Atlas2Maps/Colonnade3.png",
            "name": "Colonnade",
            "tier": 11,
            "unique": false,
        },
        "111": {
            "id": "111",
            "image": "Atlas2Maps/PrimordialPool3.png",
            "name": "Primordial Pool",
            "tier": 11,
            "unique": false,
        },
        "112": {
            "id": "112",
            "image": "Atlas2Maps/SpiderForest3.png",
            "name": "Spider Forest",
            "tier": 11,
            "unique": false,
        },
        "113": {
            "id": "113",
            "image": "Atlas2Maps/Coves3.png",
            "name": "Coves",
            "tier": 11,
            "unique": false,
        },
        "114": {
            "id": "114",
            "image": "Atlas2Maps/Waterways3.png",
            "name": "Waterways",
            "tier": 11,
            "unique": false,
        },
        "115": {
            "id": "115",
            "image": "Atlas2Maps/Factory3.png",
            "name": "Factory",
            "tier": 11,
            "unique": false,
        },
        "116": {
            "id": "116",
            "image": "Atlas2Maps/Mesa3.png",
            "name": "Mesa",
            "tier": 11,
            "unique": false,
        },
        "117": {
            "id": "117",
            "image": "Atlas2Maps/Pit3.png",
            "name": "Pit",
            "tier": 11,
            "unique": false,
        },
        "118": {
            "id": "118",
            "image": "Atlas2Maps/DefiledCathedral3.png",
            "name": "Defiled Cathedral",
            "tier": 12,
            "unique": false,
        },
        "119": {
            "id": "119",
            "image": "Atlas2Maps/Summit3.png",
            "name": "Summit",
            "tier": 12,
            "unique": false,
        },
        "120": {
            "id": "120",
            "image": "Atlas2Maps/OvergrownShrine3.png",
            "name": "Overgrown Shrine",
            "tier": 12,
            "unique": false,
        },
        "121": {
            "id": "121",
            "image": "musicbox.png",
            "name": "Acton's Nightmare",
            "tier": 12,
            "unique": true,
        },
        "122": {
            "id": "122",
            "image": "Atlas2Maps/CastleRuins3.png",
            "name": "Castle Ruins",
            "tier": 12,
            "unique": false,
        },
        "123": {
            "id": "123",
            "image": "Atlas2Maps/CrystalOre3.png",
            "name": "Crystal Ore",
            "tier": 12,
            "unique": false,
        },
        "124": {
            "id": "124",
            "image": "Atlas2Maps/Villa3.png",
            "name": "Villa",
            "tier": 12,
            "unique": false,
        },
        "125": {
            "id": "125",
            "image": "Atlas2Maps/TortureChamber3.png",
            "name": "Torture Chamber",
            "tier": 12,
            "unique": false,
        },
        "126": {
            "id": "126",
            "image": "oba.png",
            "name": "Oba's Cursed Trove",
            "tier": 12,
            "unique": true,
        },
        "127": {
            "id": "127",
            "image": "Atlas2Maps/Necropolis3.png",
            "name": "Necropolis",
            "tier": 12,
            "unique": false,
        },
        "128": {
            "id": "128",
            "image": "DeathandTaxes.png",
            "name": "Death and Taxes",
            "tier": 12,
            "unique": true,
        },
        "129": {
            "id": "129",
            "image": "Atlas2Maps/Racecourse3.png",
            "name": "Racecourse",
            "tier": 12,
            "unique": false,
        },
        "130": {
            "id": "130",
            "image": "Atlas2Maps/Abyss3.png",
            "name": "Caldera",
            "tier": 13,
            "unique": false,
        },
        "131": {
            "id": "131",
            "image": "Atlas2Maps/Ghetto3.png",
            "name": "Ghetto",
            "tier": 13,
            "unique": false,
        },
        "132": {
            "id": "132",
            "image": "Atlas2Maps/Park3.png",
            "name": "Park",
            "tier": 13,
            "unique": false,
        },
        "133": {
            "id": "133",
            "image": "Atlas2Maps/Malformation3.png",
            "name": "Malformation",
            "tier": 13,
            "unique": false,
        },
        "134": {
            "id": "134",
            "image": "Atlas2Maps/HighGardens3.png",
            "name": "Terrace",
            "tier": 13,
            "unique": false,
        },
        "135": {
            "id": "135",
            "image": "Atlas2Maps/Shrine3.png",
            "name": "Shrine",
            "tier": 13,
            "unique": false,
        },
        "136": {
            "id": "136",
            "image": "Atlas2Maps/Arsenal3.png",
            "name": "Arsenal",
            "tier": 13,
            "unique": false,
        },
        "137": {
            "id": "137",
            "image": "Atlas2Maps/Oasis3.png",
            "name": "Desert Spring",
            "tier": 13,
            "unique": false,
        },
        "138": {
            "id": "138",
            "image": "Atlas2Maps/Core3.png",
            "name": "Core",
            "tier": 13,
            "unique": false,
        },
        "139": {
            "id": "139",
            "image": "Atlas2Maps/Colosseum3.png",
            "name": "Colosseum",
            "tier": 14,
            "unique": false,
        },
        "140": {
            "id": "140",
            "image": "Atlas2Maps/AcidLakes3.png",
            "name": "Acid Lakes",
            "tier": 14,
            "unique": false,
        },
        "141": {
            "id": "141",
            "image": "Atlas2Maps/DarkForest3.png",
            "name": "Dark Forest",
            "tier": 14,
            "unique": false,
        },
        "142": {
            "id": "142",
            "image": "Atlas2Maps/Sanctuary3.png",
            "name": "Crimson Temple",
            "tier": 14,
            "unique": false,
        },
        "143": {
            "id": "143",
            "image": "Atlas2Maps/Plaza3.png",
            "name": "Plaza",
            "tier": 14,
            "unique": false,
        },
        "144": {
            "id": "144",
            "image": "Atlas2Maps/Dig3.png",
            "name": "Dig",
            "tier": 14,
            "unique": false,
        },
        "145": {
            "id": "145",
            "image": "Atlas2Maps/Palace3.png",
            "name": "Palace",
            "tier": 14,
            "unique": false,
        },
        "146": {
            "id": "146",
            "image": "Atlas2Maps/Copse3.png",
            "name": "Lava Lake",
            "tier": 15,
            "unique": false,
        },
        "147": {
            "id": "147",
            "image": "Atlas2Maps/Basilica3.png",
            "name": "Basilica",
            "tier": 15,
            "unique": false,
        },
        "148": {
            "id": "148",
            "image": "Atlas2Maps/SunkenCity3.png",
            "name": "Sunken City",
            "tier": 15,
            "unique": false,
        },
        "149": {
            "id": "149",
            "image": "Atlas2Maps/Reef3.png",
            "name": "Reef",
            "tier": 15,
            "unique": false,
        },
        "150": {
            "id": "150",
            "image": "Atlas2Maps/Carcass3.png",
            "name": "Carcass",
            "tier": 15,
            "unique": false,
        },
        "151": {
            "id": "151",
            "image": "Atlas2Maps/Chimera3.png",
            "name": "Pit of the Chimera",
            "tier": 16,
            "unique": false,
        },
        "152": {
            "id": "152",
            "image": "Atlas2Maps/Hydra3.png",
            "name": "Lair of the Hydra",
            "tier": 16,
            "unique": false,
        },
        "153": {
            "id": "153",
            "image": "Atlas2Maps/Minotaur3.png",
            "name": "Maze of the Minotaur",
            "tier": 16,
            "unique": false,
        },
        "154": {
            "id": "154",
            "image": "Atlas2Maps/Phoenix3.png",
            "name": "Forge of the Phoenix",
            "tier": 16,
            "unique": false,
        },
        "155": {
            "id": "155",
            "image": "Atlas2Maps/VaalTemple3.png",
            "name": "Vaal Temple",
            "tier": 16,
            "unique": false,
        },
        "156": {
            "id": "156",
            "image": "AtlasMaps/Atlas.png",
            "name": "The Shaper's Realm",
            "tier": 17,
            "unique": false,
        }
    }
}

export function coords() {
    return {
        "0": {"id": "0", "x": 147.8689422607422, "y": 82.31169891357422},
        "1": {"id": "1", "x": 147.9019317626953, "y": 17.169113159179688},
        "2": {"id": "2", "x": 30.076322555541992, "y": 82.60611724853516},
        "3": {"id": "3", "x": 30.01238250732422, "y": 14.739068031311035},
        "4": {"id": "4", "x": 148.6935272216797, "y": 74.19773864746094},
        "5": {"id": "5", "x": 141.5360870361328, "y": 82.41065216064453},
        "6": {"id": "6", "x": 142.92140197753906, "y": 17.432981491088867},
        "7": {"id": "7", "x": 148.0668487548828, "y": 24.788320541381836},
        "8": {"id": "8", "x": 27.603784561157227, "y": 21.730398178100586},
        "9": {"id": "9", "x": 36.38557052612305, "y": 79.85647583007812},
        "10": {"id": "10", "x": 136.81944274902344, "y": 15.58590030670166},
        "11": {"id": "11", "x": 139.98585510253906, "y": 77.79295349121094},
        "12": {"id": "12", "x": 46.2757453918457, "y": 82.98978424072266},
        "13": {"id": "13", "x": 32.953857421875, "y": 25.69499397277832},
        "14": {"id": "14", "x": 27.646413803100586, "y": 27.933069229125977},
        "15": {"id": "15", "x": 144.4386444091797, "y": 30.6923828125},
        "16": {"id": "16", "x": 147.53909301757812, "y": 64.17073059082031},
        "17": {"id": "17", "x": 29.223722457885742, "y": 72.9930419921875},
        "18": {"id": "18", "x": 36.12979507446289, "y": 16.763996124267578},
        "19": {"id": "19", "x": 143.61404418945312, "y": 68.656494140625},
        "20": {"id": "20", "x": 134.47760009765625, "y": 83.07032012939453},
        "21": {"id": "21", "x": 29.863174438476562, "y": 64.95728302001953},
        "22": {"id": "22", "x": 138.89739990234375, "y": 72.94436645507812},
        "23": {"id": "23", "x": 140.7115020751953, "y": 21.621896743774414},
        "24": {"id": "24", "x": 134.01583862304688, "y": 18.521440505981445},
        "25": {"id": "25", "x": 37.38737869262695, "y": 73.80300903320312},
        "26": {"id": "26", "x": 38.90074920654297, "y": 21.45330238342285},
        "27": {"id": "27", "x": 35.53297424316406, "y": 33.85865020751953},
        "28": {"id": "28", "x": 28.904001235961914, "y": 35.691741943359375},
        "29": {"id": "29", "x": 146.40048217773438, "y": 53.593631744384766},
        "30": {"id": "30", "x": 146.31871032714844, "y": 42.104705810546875},
        "31": {"id": "31", "x": 126.79242706298828, "y": 85.6430435180664},
        "32": {"id": "32", "x": 31.227336883544922, "y": 44.23906707763672},
        "33": {"id": "33", "x": 131.80593872070312, "y": 79.93688201904297},
        "34": {"id": "34", "x": 45.74287796020508, "y": 17.190296173095703},
        "35": {"id": "35", "x": 38.19735336303711, "y": 26.249183654785156},
        "36": {"id": "36", "x": 39.83860778808594, "y": 69.79579162597656},
        "37": {"id": "37", "x": 138.13877868652344, "y": 26.041698455810547},
        "38": {"id": "38", "x": 141.3711700439453, "y": 62.059776306152344},
        "39": {"id": "39", "x": 142.29470825195312, "y": 42.995262145996094},
        "40": {"id": "40", "x": 31.845470428466797, "y": 55.02447509765625},
        "41": {"id": "41", "x": 45.74287033081055, "y": 54.896583557128906},
        "42": {"id": "42", "x": 130.48658752441406, "y": 30.164648056030273},
        "43": {"id": "43", "x": 134.97235107421875, "y": 43.2921142578125},
        "44": {"id": "44", "x": 53.766761779785156, "y": 76.6385269165039},
        "45": {"id": "45", "x": 117.45806884765625, "y": 83.40015411376953},
        "46": {"id": "46", "x": 137.41810607910156, "y": 49.68551254272461},
        "47": {"id": "47", "x": 132.3336639404297, "y": 70.56954193115234},
        "48": {"id": "48", "x": 41.032249450683594, "y": 48.885746002197266},
        "49": {"id": "49", "x": 42.48167419433594, "y": 34.77519607543945},
        "50": {"id": "50", "x": 42.18326187133789, "y": 42.448604583740234},
        "51": {"id": "51", "x": 42.609561920166016, "y": 62.39947509765625},
        "52": {"id": "52", "x": 49.34511184692383, "y": 60.417179107666016},
        "53": {"id": "53", "x": 50.7305908203125, "y": 22.05012321472168},
        "54": {"id": "54", "x": 117.68895721435547, "y": 79.27720642089844},
        "55": {"id": "55", "x": 129.03530883789062, "y": 40.9832649230957},
        "56": {"id": "56", "x": 45.23130798339844, "y": 45.45402526855469},
        "57": {"id": "57", "x": 125.20922088623047, "y": 20.302555084228516},
        "58": {"id": "58", "x": 50.38955307006836, "y": 30.064573287963867},
        "59": {"id": "59", "x": 65.40996551513672, "y": 79.87091827392578},
        "60": {"id": "60", "x": 62.309513092041016, "y": 83.82894897460938},
        "61": {"id": "61", "x": 52.18354797363281, "y": 68.6894760131836},
        "62": {"id": "62", "x": 46.93915939331055, "y": 68.986328125},
        "63": {"id": "63", "x": 61.287017822265625, "y": 19.609901428222656},
        "64": {"id": "64", "x": 59.01115036010742, "y": 14.365510940551758},
        "65": {"id": "65", "x": 104.46253204345703, "y": 86.40166473388672},
        "66": {"id": "66", "x": 130.88238525390625, "y": 53.9458122253418},
        "67": {"id": "67", "x": 133.2572021484375, "y": 59.94882583618164},
        "68": {"id": "68", "x": 126.72645568847656, "y": 64.99531555175781},
        "69": {"id": "69", "x": 122.99930572509766, "y": 49.03125762939453},
        "70": {"id": "70", "x": 51.919681549072266, "y": 43.39107131958008},
        "71": {"id": "71", "x": 110.59748077392578, "y": 78.02383422851562},
        "72": {"id": "72", "x": 110.33361053466797, "y": 82.11380004882812},
        "73": {"id": "73", "x": 58.46794128417969, "y": 26.099977493286133},
        "74": {"id": "74", "x": 47.575965881347656, "y": 38.33480453491211},
        "75": {"id": "75", "x": 108.15670013427734, "y": 17.037179946899414},
        "76": {"id": "76", "x": 113.22970581054688, "y": 13.752391815185547},
        "77": {"id": "77", "x": 57.7907600402832, "y": 69.25019836425781},
        "78": {"id": "78", "x": 77.35002899169922, "y": 85.70901489257812},
        "79": {"id": "79", "x": 74.87625885009766, "y": 89.4361572265625},
        "80": {"id": "80", "x": 92.72037506103516, "y": 86.86343383789062},
        "81": {"id": "81", "x": 71.57789611816406, "y": 16.245574951171875},
        "82": {"id": "82", "x": 81.703857421875, "y": 17.53193473815918},
        "83": {"id": "83", "x": 78.2735595703125, "y": 13.441969871520996},
        "84": {"id": "84", "x": 60.561580657958984, "y": 31.64738655090332},
        "85": {"id": "85", "x": 78.5375747680664, "y": 79.36524200439453},
        "86": {"id": "86", "x": 53.5688591003418, "y": 56.782405853271484},
        "87": {"id": "87", "x": 123.0982666015625, "y": 35.639923095703125},
        "88": {"id": "88", "x": 98.063720703125, "y": 80.76146697998047},
        "89": {"id": "89", "x": 54.06361389160156, "y": 34.38655090332031},
        "90": {"id": "90", "x": 94.86431884765625, "y": 16.740327835083008},
        "91": {"id": "91", "x": 99.91080474853516, "y": 13.54092025756836},
        "92": {"id": "92", "x": 121.11925506591797, "y": 25.777830123901367},
        "93": {"id": "93", "x": 119.5030517578125, "y": 71.46009826660156},
        "94": {"id": "94", "x": 123.5600357055664, "y": 74.92337799072266},
        "95": {"id": "95", "x": 121.56529235839844, "y": 55.47050857543945},
        "96": {"id": "96", "x": 117.49105834960938, "y": 66.18272399902344},
        "97": {"id": "97", "x": 85.6618881225586, "y": 81.05831909179688},
        "98": {"id": "98", "x": 69.36799621582031, "y": 21.984718322753906},
        "99": {"id": "99", "x": 103.61509704589844, "y": 77.33352661132812},
        "100": {"id": "100", "x": 117.45806884765625, "y": 32.902286529541016},
        "101": {"id": "101", "x": 67.7847900390625, "y": 74.98934936523438},
        "102": {"id": "102", "x": 57.29600524902344, "y": 55.43008041381836},
        "103": {"id": "103", "x": 109.91082763671875, "y": 24.95296859741211},
        "104": {"id": "104", "x": 101.75788879394531, "y": 19.181114196777344},
        "105": {"id": "105", "x": 106.96929168701172, "y": 21.621898651123047},
        "106": {"id": "106", "x": 57.7907600402832, "y": 40.25762939453125},
        "107": {"id": "107", "x": 74.81028747558594, "y": 69.61302185058594},
        "108": {"id": "108", "x": 81.14313507080078, "y": 73.14226531982422},
        "109": {"id": "109", "x": 65.17908477783203, "y": 57.8708610534668},
        "110": {"id": "110", "x": 111.48804473876953, "y": 58.0027961730957},
        "111": {"id": "111", "x": 63.62618637084961, "y": 44.771942138671875},
        "112": {"id": "112", "x": 98.92129516601562, "y": 71.03131103515625},
        "113": {"id": "113", "x": 86.58543395996094, "y": 73.83491516113281},
        "114": {"id": "114", "x": 70.205810546875, "y": 32.52986526489258},
        "115": {"id": "115", "x": 113.66570281982422, "y": 43.86155700683594},
        "116": {"id": "116", "x": 92.9512710571289, "y": 24.062685012817383},
        "117": {"id": "117", "x": 108.71742248535156, "y": 34.782352447509766},
        "118": {"id": "118", "x": 105.25414276123047, "y": 54.737422943115234},
        "119": {"id": "119", "x": 69.72228240966797, "y": 45.60322570800781},
        "120": {"id": "120", "x": 98.98726654052734, "y": 27.295076370239258},
        "121": {"id": "121", "x": 89.28204345703125, "y": 31.496564865112305},
        "122": {"id": "122", "x": 92.68739318847656, "y": 72.911376953125},
        "123": {"id": "123", "x": 112.77440643310547, "y": 51.07624435424805},
        "124": {"id": "124", "x": 111.38909149169922, "y": 38.27861022949219},
        "125": {"id": "125", "x": 75.79705810546875, "y": 26.995208740234375},
        "126": {"id": "126", "x": 85.69487762451172, "y": 25.184125900268555},
        "127": {"id": "127", "x": 69.03544616699219, "y": 52.98640060424805},
        "128": {"id": "128", "x": 64.684326171875, "y": 50.51552200317383},
        "129": {"id": "129", "x": 68.4114761352539, "y": 64.3686294555664},
        "130": {"id": "130", "x": 108.18968200683594, "y": 50.58148956298828},
        "131": {"id": "131", "x": 92.06070709228516, "y": 66.21570587158203},
        "132": {"id": "132", "x": 109.01427459716797, "y": 43.68791961669922},
        "133": {"id": "133", "x": 75.62654113769531, "y": 30.512187957763672},
        "134": {"id": "134", "x": 78.27356719970703, "y": 66.87538146972656},
        "135": {"id": "135", "x": 108.74588012695312, "y": 62.19264221191406},
        "136": {"id": "136", "x": 70.53526306152344, "y": 61.11906051635742},
        "137": {"id": "137", "x": 96.38156127929688, "y": 33.825828552246094},
        "138": {"id": "138", "x": 68.40074920654297, "y": 39.848167419433594},
        "139": {"id": "139", "x": 75.60189819335938, "y": 59.42108917236328},
        "140": {"id": "140", "x": 102.4677505493164, "y": 60.753902435302734},
        "141": {"id": "141", "x": 81.70132446289062, "y": 30.49087142944336},
        "142": {"id": "142", "x": 105.05624389648438, "y": 37.38805389404297},
        "143": {"id": "143", "x": 73.79345703125, "y": 34.77519226074219},
        "144": {"id": "144", "x": 103.3410873413086, "y": 68.59052276611328},
        "145": {"id": "145", "x": 103.44004821777344, "y": 46.09572219848633},
        "146": {"id": "146", "x": 75.70084381103516, "y": 53.385093688964844},
        "147": {"id": "147", "x": 99.77886962890625, "y": 38.34457778930664},
        "148": {"id": "148", "x": 74.88052368164062, "y": 39.059513092041016},
        "149": {"id": "149", "x": 81.2323989868164, "y": 34.81782150268555},
        "150": {"id": "150", "x": 96.71139526367188, "y": 64.13774108886719},
        "151": {"id": "151", "x": 79.92274475097656, "y": 58.761417388916016},
        "152": {"id": "152", "x": 79.88833618164062, "y": 40.78998565673828},
        "153": {"id": "153", "x": 97.14018249511719, "y": 58.8273811340332},
        "154": {"id": "154", "x": 97.27171325683594, "y": 40.65626907348633},
        "155": {"id": "155", "x": 83.61690521240234, "y": 65.78692626953125},
        "156": {"id": "156", "x": 88.60355377197266, "y": 49.89796447753906}
    }
}

export function sextants() {
    return {
        "0": {"id": "0", "near": ["4", "5", "11"]},
        "1": {"id": "1", "near": ["6", "7", "23"]},
        "2": {"id": "2", "near": ["9", "17"]},
        "3": {"id": "3", "near": ["8", "18"]},
        "4": {"id": "4", "near": ["0", "11", "19"]},
        "5": {"id": "5", "near": ["0", "11", "20"]},
        "6": {"id": "6", "near": ["1", "7", "10", "23", "24"]},
        "7": {"id": "7", "near": ["1", "6", "15", "23"]},
        "8": {"id": "8", "near": ["3", "13", "14"]},
        "9": {"id": "9", "near": ["2", "25"]},
        "10": {"id": "10", "near": ["6", "23", "24"]},
        "11": {"id": "11", "near": ["0", "4", "5", "20", "22", "33"]},
        "12": {"id": "12", "near": []},
        "13": {"id": "13", "near": ["8", "14", "18", "26", "27", "35"]},
        "14": {"id": "14", "near": ["8", "13", "28"]},
        "15": {"id": "15", "near": ["7", "37"]},
        "16": {"id": "16", "near": ["19", "38"]},
        "17": {"id": "17", "near": ["2", "21", "25"]},
        "18": {"id": "18", "near": ["3", "13", "26", "34", "35"]},
        "19": {"id": "19", "near": ["4", "16", "22", "38"]},
        "20": {"id": "20", "near": ["5", "11", "31", "33"]},
        "21": {"id": "21", "near": ["17"]},
        "22": {"id": "22", "near": ["11", "19", "47"]},
        "23": {"id": "23", "near": ["1", "6", "7", "10", "24", "37"]},
        "24": {"id": "24", "near": ["6", "10", "23", "37", "57"]},
        "25": {"id": "25", "near": ["9", "17", "36"]},
        "26": {"id": "26", "near": ["13", "18", "34", "35"]},
        "27": {"id": "27", "near": ["13", "28", "35", "49"]},
        "28": {"id": "28", "near": ["14", "27", "32"]},
        "29": {"id": "29", "near": []},
        "30": {"id": "30", "near": ["39"]},
        "31": {"id": "31", "near": ["20", "33", "45"]},
        "32": {"id": "32", "near": ["28"]},
        "33": {"id": "33", "near": ["11", "20", "31", "47", "94"]},
        "34": {"id": "34", "near": ["18", "26", "53"]},
        "35": {"id": "35", "near": ["13", "18", "26", "27", "49"]},
        "36": {"id": "36", "near": ["25", "51", "62"]},
        "37": {"id": "37", "near": ["15", "23", "24", "42"]},
        "38": {"id": "38", "near": ["16", "19", "67"]},
        "39": {"id": "39", "near": ["30", "43", "46"]},
        "40": {"id": "40", "near": []},
        "41": {"id": "41", "near": ["48", "51", "52", "56", "86"]},
        "42": {"id": "42", "near": ["37", "87"]},
        "43": {"id": "43", "near": ["39", "46", "55"]},
        "44": {"id": "44", "near": ["61", "77"]},
        "45": {"id": "45", "near": ["31", "54", "71", "72"]},
        "46": {"id": "46", "near": ["39", "43", "66"]},
        "47": {"id": "47", "near": ["22", "33", "68"]},
        "48": {"id": "48", "near": ["41", "50", "56"]},
        "49": {"id": "49", "near": ["27", "35", "50", "58", "74"]},
        "50": {"id": "50", "near": ["48", "49", "56", "74"]},
        "51": {"id": "51", "near": ["36", "41", "52", "62"]},
        "52": {"id": "52", "near": ["41", "51", "61", "62", "86", "102"]},
        "53": {"id": "53", "near": ["34", "58", "73"]},
        "54": {"id": "54", "near": ["45", "71", "72", "93", "94"]},
        "55": {"id": "55", "near": ["43", "87"]},
        "56": {"id": "56", "near": ["41", "48", "50", "70", "74"]},
        "57": {"id": "57", "near": ["24", "92"]},
        "58": {"id": "58", "near": ["49", "53", "73", "74", "89"]},
        "59": {"id": "59", "near": ["60", "101"]},
        "60": {"id": "60", "near": ["59"]},
        "61": {"id": "61", "near": ["44", "52", "62", "77"]},
        "62": {"id": "62", "near": ["36", "51", "52", "61"]},
        "63": {"id": "63", "near": ["64", "73", "98"]},
        "64": {"id": "64", "near": ["63"]},
        "65": {"id": "65", "near": ["72", "88", "99"]},
        "66": {"id": "66", "near": ["46", "67", "69", "95"]},
        "67": {"id": "67", "near": ["38", "66", "68"]},
        "68": {"id": "68", "near": ["47", "67", "93", "96"]},
        "69": {"id": "69", "near": ["66", "95"]},
        "70": {"id": "70", "near": ["56", "74", "89", "106"]},
        "71": {"id": "71", "near": ["45", "54", "72", "99"]},
        "72": {"id": "72", "near": ["45", "54", "65", "71", "99"]},
        "73": {"id": "73", "near": ["53", "58", "63", "84", "89"]},
        "74": {"id": "74", "near": ["49", "50", "56", "58", "70", "89"]},
        "75": {"id": "75", "near": ["76", "91", "103", "104", "105"]},
        "76": {"id": "76", "near": ["75"]},
        "77": {"id": "77", "near": ["44", "61"]},
        "78": {"id": "78", "near": ["79", "85", "97"]},
        "79": {"id": "79", "near": ["78"]},
        "80": {"id": "80", "near": ["88", "97"]},
        "81": {"id": "81", "near": ["83", "98"]},
        "82": {"id": "82", "near": ["83", "126"]},
        "83": {"id": "83", "near": ["81", "82"]},
        "84": {"id": "84", "near": ["73", "89", "106", "114"]},
        "85": {"id": "85", "near": ["78", "97", "108"]},
        "86": {"id": "86", "near": ["41", "52", "102"]},
        "87": {"id": "87", "near": ["42", "55", "100"]},
        "88": {"id": "88", "near": ["65", "80", "99", "122"]},
        "89": {"id": "89", "near": ["58", "70", "73", "74", "84", "106"]},
        "90": {"id": "90", "near": ["91", "104", "116"]},
        "91": {"id": "91", "near": ["75", "90", "104"]},
        "92": {"id": "92", "near": ["57", "100"]},
        "93": {"id": "93", "near": ["54", "68", "94", "96"]},
        "94": {"id": "94", "near": ["33", "54", "93"]},
        "95": {"id": "95", "near": ["66", "69"]},
        "96": {"id": "96", "near": ["68", "93", "135"]},
        "97": {"id": "97", "near": ["78", "80", "85", "108", "113"]},
        "98": {"id": "98", "near": ["63", "81", "125"]},
        "99": {"id": "99", "near": ["65", "71", "72", "88", "112", "144"]},
        "100": {"id": "100", "near": ["87", "92", "117", "124"]},
        "101": {"id": "101", "near": ["59", "107"]},
        "102": {"id": "102", "near": ["52", "86", "109", "128"]},
        "103": {"id": "103", "near": ["75", "105"]},
        "104": {"id": "104", "near": ["75", "90", "91", "105", "120"]},
        "105": {"id": "105", "near": ["75", "103", "104"]},
        "106": {"id": "106", "near": ["70", "84", "89", "111"]},
        "107": {"id": "107", "near": ["101", "108", "129", "134", "136", "155"]},
        "108": {"id": "108", "near": ["85", "97", "107", "113", "134", "155"]},
        "109": {"id": "109", "near": ["102", "127", "128", "129", "136"]},
        "110": {"id": "110", "near": ["118", "123", "130", "135", "140"]},
        "111": {"id": "111", "near": ["106", "119", "128", "138"]},
        "112": {"id": "112", "near": ["99", "122", "131", "144", "150"]},
        "113": {"id": "113", "near": ["97", "108", "122", "131", "155"]},
        "114": {"id": "114", "near": ["84", "125", "133", "138", "143", "148"]},
        "115": {"id": "115", "near": ["123", "124", "130", "132"]},
        "116": {"id": "116", "near": ["90", "120", "121", "126"]},
        "117": {"id": "117", "near": ["100", "124", "132", "142", "147"]},
        "118": {"id": "118", "near": ["110", "123", "130", "135", "140", "145", "153"]},
        "119": {"id": "119", "near": ["111", "127", "128", "138", "148"]},
        "120": {"id": "120", "near": ["104", "116", "137"]},
        "121": {"id": "121", "near": ["116", "126", "137", "141", "149"]},
        "122": {"id": "122", "near": ["88", "112", "113", "131", "150"]},
        "123": {"id": "123", "near": ["110", "115", "118", "130", "132"]},
        "124": {"id": "124", "near": ["100", "115", "117", "132", "142"]},
        "125": {"id": "125", "near": ["98", "114", "133", "141", "143", "149"]},
        "126": {"id": "126", "near": ["82", "116", "121", "141"]},
        "127": {"id": "127", "near": ["109", "119", "128", "136", "139", "146"]},
        "128": {"id": "128", "near": ["102", "109", "111", "119", "127"]},
        "129": {"id": "129", "near": ["107", "109", "136", "139"]},
        "130": {"id": "130", "near": ["110", "115", "118", "123", "132", "145"]},
        "131": {"id": "131", "near": ["112", "113", "122", "150", "153", "155"]},
        "132": {"id": "132", "near": ["115", "117", "123", "124", "130", "142", "145"]},
        "133": {"id": "133", "near": ["114", "125", "141", "143", "148", "149"]},
        "134": {"id": "134", "near": ["107", "108", "136", "139", "151", "155"]},
        "135": {"id": "135", "near": ["96", "110", "118", "140", "144"]},
        "136": {"id": "136", "near": ["107", "109", "127", "129", "134", "139", "146", "151"]},
        "137": {"id": "137", "near": ["120", "121", "142", "147", "154"]},
        "138": {"id": "138", "near": ["111", "114", "119", "143", "148"]},
        "139": {"id": "139", "near": ["127", "129", "134", "136", "146", "151"]},
        "140": {"id": "140", "near": ["110", "118", "135", "144", "150", "153"]},
        "141": {"id": "141", "near": ["121", "125", "126", "133", "143", "149"]},
        "142": {"id": "142", "near": ["117", "124", "132", "137", "145", "147", "154"]},
        "143": {"id": "143", "near": ["114", "125", "133", "138", "141", "148", "149", "152"]},
        "144": {"id": "144", "near": ["99", "112", "135", "140", "150"]},
        "145": {"id": "145", "near": ["118", "130", "132", "142", "147", "154"]},
        "146": {"id": "146", "near": ["127", "136", "139", "151"]},
        "147": {"id": "147", "near": ["117", "137", "142", "145", "154"]},
        "148": {"id": "148", "near": ["114", "119", "133", "138", "143", "149", "152"]},
        "149": {"id": "149", "near": ["121", "125", "133", "141", "143", "148", "152"]},
        "150": {"id": "150", "near": ["112", "122", "131", "140", "144", "153"]},
        "151": {"id": "151", "near": ["134", "136", "139", "146", "155"]},
        "152": {"id": "152", "near": ["143", "148", "149"]},
        "153": {"id": "153", "near": ["118", "131", "140", "150"]},
        "154": {"id": "154", "near": ["137", "142", "145", "147"]},
        "155": {"id": "155", "near": ["107", "108", "113", "131", "134", "151"]},
        "156": {"id": "156", "near": []}
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/atlas.js
// module id = 28
// module chunks = 0